import React from 'react';
import type { AlertCardType } from '@/domain/Notifications/Notifications';
import { resolveCardType } from '../constants';
import SystemAlertCard from '../cards/SystemAlertCard';
import StrategyCard from '../cards/StrategyCard';
import ForecastAlertCard from '../cards/ForecastAlertCard';

interface NotificationCardFactoryProps {
	readonly act: AlertCardType & { onDismiss?: () => void };
}

export default function NotificationCardFactory({ act }: NotificationCardFactoryProps) {
	const cardType = resolveCardType(act);

	switch (cardType) {
		case 'system':
			return <SystemAlertCard act={act} />;
		case 'strategy':
			return <StrategyCard act={act} />;
		case 'forecast':
		default:
			return <ForecastAlertCard act={act} />;
	}
}
